var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _c("div", { staticClass: "login-form" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "text-login" }, [
            _vm._v(_vm._s(_vm.$t("general.system_name")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-box" }, [
            _c("div", { staticClass: "text-center mt-1 font-weight-bold" }, [
              _c("div", {
                staticStyle: { "font-size": "13px", "font-weight": "300" },
                domProps: {
                  innerHTML: _vm._s(_vm.$t("login.sp_input_code_message"))
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-4", staticStyle: { "font-size": "14px" } },
              [_vm._v("シークレットキー:")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-center justify-content-center mb-3"
              },
              [
                _c("span", { staticStyle: { width: "300px" } }, [
                  _vm._v(_vm._s(_vm.secretKey))
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-clipboard-cir mt-3",
                    staticStyle: { display: "inline-flex", color: "white" },
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.copyToClipboard(_vm.secretKey)
                      }
                    }
                  },
                  [_vm._m(1)]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 d-flex" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-pink-53 w-100",
                  on: {
                    click: function($event) {
                      return _vm.next()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("button.next")) +
                      "\n              "
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "logo-link", attrs: { href: "#" } }, [
      _c("img", {
        attrs: { src: require("@/assets/img/logo_jtb.png"), alt: "Logo" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { display: "contents" } }, [
      _c("i", { staticClass: "icon-copy-orange" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ae91810", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ae91810","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/sp/Login/LoginFirstMfa.vue
// module id = null
// module chunks = 